interface ResourceAbortState {
  controller: AbortController | null;
  stopped: boolean;
}

const resourceAbortState: ResourceAbortState = {
  controller: null,
  stopped: false,
};

export const createResourceAbortController = (): AbortController => {
  if (resourceAbortState.controller) {
    resourceAbortState.controller.abort();
  }

  const controller = new AbortController();

  resourceAbortState.controller = controller;
  resourceAbortState.stopped = false;

  return controller;
};

export const getResourceAbortController = (): AbortController | null => {
  return resourceAbortState.controller;
};

export const abortResourceLoading = (): void => {
  resourceAbortState.stopped = true;
  if (resourceAbortState.controller) {
    resourceAbortState.controller.abort();
    resourceAbortState.controller = null;
  }
};

export const isResourceStreamingStopped = (): boolean => {
  return resourceAbortState.stopped;
};

export const resetResourceAbortController = (): void => {
  resourceAbortState.controller = null;
  resourceAbortState.stopped = false;
};
